import { render, staticRenderFns } from "./PageAddUser.vue?vue&type=template&id=38fc0f0b&scoped=true"
import script from "./PageAddUser.vue?vue&type=script&lang=js"
export * from "./PageAddUser.vue?vue&type=script&lang=js"
import style0 from "./PageAddUser.vue?vue&type=style&index=0&id=38fc0f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc0f0b",
  null
  
)

export default component.exports